<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="apiLoaded || errorText">
        <div v-if="apiLoaded" class="wrap">
          <div class="header">
            <h1>Отчеты</h1>
            <div>
              <v-btn
                  v-if="$user.role === 'ROLE_VNII' || $user.role === 'ROLE_MINTRUD' || $user.role === 'ROLE_ADMIN'"
                  @click="$router.push('/reports/registry')"
                  outlined
              >
                реестр отчетов
              </v-btn>
            </div>
          </div>

          <template v-if="$user.role !== 'ROLE_CZN_TERRITORIAL'">
            <div class="reports-filters">
              <div>
                <h4>Уровень мониторинга:</h4>
                <v-radio-group v-model="monitoringLevel" row hide-details class="reports-filters__level" @change="loadData()">
                  <v-radio label="Регионы" value="region"></v-radio>
                  <v-radio label="ЦЗН" value="czn"></v-radio>
                </v-radio-group>
              </div>
              <div class="reports-filters__selector">
                <department-info v-if="monitoringLevel === 'czn'" @depObj="department = $event; loadData()"></department-info>
                <template v-else-if="monitoringLevel === 'region'">
                  <span v-if="$user.role === 'ROLE_REGIONAL_AGENCY' || $user.role === 'ROLE_REGIONAL_ADMINISTRATOR' || $user.role === 'ROLE_CZN_MANAGER'">
                    {{ userRegion.nameWithNetType }}
                  </span>

                  <v-autocomplete v-else-if="$user.role === 'ROLE_VNII' || $user.role === 'ROLE_MINTRUD' || $user.role === 'ROLE_ADMIN'"
                                  style="width: 500px;"
                                  label="Регион"
                                  :items="$cznDepartmentsByRegionList"
                                  item-text="nameWithNetType"
                                  return-object
                                  hide-details
                                  v-model="userRegion"
                                  @input="loadData()"
                  ></v-autocomplete>
                </template>
              </div>
              <div class="reports-filters__wave">
                <ModernizationWave :count="userRegion?.modernizationWave" />
              </div>
            </div>
          </template>
          <template v-else>
            <span>{{ $user.department.name }}</span>
          </template>

          <template v-if="!loading && canView">
            <section class="reports-block">
              <div class="reports-block__title">Новые отчетные формы</div>
              <div class="list">
                <table>
                  <tbody>
                  <tr v-for="config in newReports" :key="config.id">
                    <td>
                      {{ config.content.title }}
                    </td>
                    <td class="text-right">
                      <v-btn
                          @click="previewReport(config.content.context)"
                          outlined
                      >
                        Открыть отчетную форму
                      </v-btn>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="newReports.length === 0" class="reports-block__empty">
                  Нет новых отчетных форм к заполнению
                </div>
              </div>
            </section>

            <section class="reports-block">
              <div class="reports-block__title">Активные отчетные формы</div>
              <div class="list">
                <table class="reports-table">
                  <colgroup>
                    <col class="reports-table__col-name">
                    <col class="reports-table__col-meta">
                    <col class="reports-table__col-meta">
                    <col class="reports-table__col-meta">
                    <col class="reports-table__col-action">
                  </colgroup>
                  <thead>
                  <tr>
                    <th>Наименование</th>
                    <th>Дата создания</th>
                    <th>Дата отправки</th>
                    <th>Статус</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="report in draftReports" :key="report.id">
                    <td>
                      <router-link :to="'/reports/' + report.id">{{ findNameByContext(report.context) }}</router-link>
                    </td>
                    <td>{{ report.createdDateTime | dateFormat }}</td>
                    <td v-if="report.sendDateTime">{{ report.sendDateTime | dateFormat }}</td>
                    <td v-else>—</td>
                    <td>{{ reportStatuses[report.status] }}</td>
                    <td>
                      <v-btn
                          v-if="canView"
                          small
                          outlined
                          @click="openExport(report)"
                      >
                        <v-icon small class="mt-1">mdi-tray-arrow-up</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="draftReports.length === 0" class="reports-block__empty">
                  Нет отчетных форм в статусе «Черновик»
                </div>
              </div>
            </section>

            <section class="reports-block">
              <div class="reports-block__title">Отправленные отчетные формы</div>
              <div class="list">
                <table class="reports-table">
                  <colgroup>
                    <col class="reports-table__col-name">
                    <col class="reports-table__col-meta">
                    <col class="reports-table__col-meta">
                    <col class="reports-table__col-meta">
                    <col class="reports-table__col-action">
                  </colgroup>
                  <thead>
                  <tr>
                    <th>Наименование</th>
                    <th>Дата создания</th>
                    <th>Дата отправки</th>
                    <th>Статус</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="report in sentReports" :key="report.id">
                    <td>
                      <router-link :to="'/reports/' + report.id">{{ findNameByContext(report.context) }}</router-link>
                    </td>
                    <td>{{ report.createdDateTime | dateFormat }}</td>
                    <td v-if="report.sendDateTime">{{ report.sendDateTime | dateFormat }}</td>
                    <td v-else>—</td>
                    <td>{{ reportStatuses[report.status] }}</td>
                    <td>
                      <v-btn
                          v-if="canView"
                          small
                          outlined
                          @click="openExport(report)"
                      >
                        <v-icon small class="mt-1">mdi-tray-arrow-up</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="sentReports.length === 0" class="reports-block__empty">
                  Нет отправленных отчетных форм
                </div>
              </div>
            </section>
          </template>
        </div>
        <div v-if="errorText != null" class="error" style="position: fixed;bottom: 0">
          Ошибка: {{ errorText }}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
    <loader-dialog :show="loading" msg="Загрузка"></loader-dialog>
    <v-dialog
        v-model="exportDialog"
        max-width="500px"
        persistent
    >
      <StandardReportExportDialog
          v-if="exportReport"
          :report="exportReport"
          :key="exportDialogKey"
          @close="closeExport"
      />
    </v-dialog>
  </div>
</template>

<script>
import departmentInfo from "@/components/elements/DepartmentInfo";
import {
  getFormsByDomainAndCznIdAndContext,
  getFormsByDomainAndRegionCodeAndContext
} from "@/modules/api.forms";
import {reportStatuses} from "@/modules/ApplicationRepository";
import {getActiveDomainConfigs} from "@/modules/api.configs";
import LoaderDialog from "@/components/elements/LoaderDialog.vue";
import ModernizationWave from "@/components/elements/ModernizationWave";
import StandardReportExportDialog from "@/components/standard_report/StandardReportExportDialog.vue";
import {
  StandardReportPermissions,
} from "@/modules/standardReportPermissions";

export default {
  name: 'StandardReports',
  components: {
    LoaderDialog,
    departmentInfo,
    ModernizationWave,
    StandardReportExportDialog,
  },
  data: () => ({
    domainReport: 'standard_report',
    reports: [],
    configs: [],
    loading: false,
    monitoringLevel: "region",
    department: {
      name: null,
    },
    userRegion: {},
    reportStatuses: reportStatuses,
    apiLoaded: false,
    errorText: null,
    exportDialog: false,
    exportDialogKey: 0,
    exportReport: null,
  }),
  computed: {
    permissions() {
      return new StandardReportPermissions(this.$user, this.$cznDepartmentsByRegionList)
    },
    currentTarget() {
      if (this.monitoringLevel === 'czn') {
        return {
          level: 'czn',
          regionCode: this.department?.region?.code || this.userRegion?.code || null,
          cznId: this.department?.id ?? null,
        }
      }
      return {
        level: 'region',
        regionCode: this.userRegion?.code || null,
        cznId: null,
      }
    },
    canView() {
      return this.permissions.canView(this.currentTarget)
    },
    canEdit() {
      return this.permissions.canEdit(this.currentTarget)
    },
    newReports() {
      return this.configs.filter(config => !config.filled)
    },
    draftReports() {
      return this.reports.filter(report => report.status === 'DRAFT')
    },
    sentReports() {
      return this.reports.filter(report => report.status === 'SENT')
    },
  },
  methods: {
    async loadData() {
      if (!this.canView) return;

      this.loading = true
      if (this.monitoringLevel === 'region') {
        this.department = {
          name: null,
        }
      }

      await this.loadReportConfigs()
      await this.processConfigs()
      await this.loadReports()
      this.loading = false
    },
    async loadReportConfigs() {
      this.configs = (await getActiveDomainConfigs(this.domainReport)).payload
    },
    async processConfigs() {
        this.configs.sort((a, b) => (a.createdDate < b.createdDate) ? 1 : -1)

        if (this.monitoringLevel === 'region') {
          this.configs = this.configs.filter(config => config.content.regions.includes(this.userRegion.code))
        }
        if (this.monitoringLevel === 'czn') {
          this.configs = this.configs.filter(config => config.content.czns.includes(this.department.id))
        }
    },
    async loadReports() {
      this.reports = []
      for (const config of this.configs) {
        let reports = [];

        if (this.monitoringLevel === 'region') {
          reports = (await getFormsByDomainAndRegionCodeAndContext(
              this.domainReport,
              this.userRegion.code,
              config.content.context
          )).payload;
        }

        if (this.monitoringLevel === 'czn') {
          reports = (await getFormsByDomainAndCznIdAndContext(
              this.domainReport,
              this.department.id,
              config.content.context
          )).payload;
        }

        config.filled = reports.length
        this.reports = this.reports.concat(reports.filter(newReport =>
            !this.reports.some(existingReport => existingReport.id === newReport.id)
        ))
      }
    },
    findNameByContext(context) {
        return this.configs.find(config => config.content.context === context)?.content.title
    },
    previewTarget(context) {
      const regionCode = this.monitoringLevel === 'region'
          ? this.userRegion.code
          : this.department.region.code;
      const cznId = this.monitoringLevel === 'region'
          ? null
          : this.department.id;
      return { context, regionCode, cznId };
    },
    previewRoute(context) {
      const { context: reportContext, regionCode, cznId } = this.previewTarget(context);
      return {
        path: '/reports/preview',
        query: {
          context: reportContext,
          regionCode,
          ...(cznId != null ? { cznId: String(cznId) } : {}),
        },
      };
    },
    openExport(report) {
      this.exportReport = report
      this.exportDialogKey++
      this.exportDialog = true
    },
    closeExport() {
      this.exportDialog = false
      this.exportReport = null
      this.exportDialogKey++
    },
    async previewReport(context) {
      await this.$router.push(this.previewRoute(context));
    },
  },
  filters: {
    dateFormat: function (date) {
      if (date == null) {
        return ''
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    }
  },
  async beforeMount() {
    this.apiLoaded = true;
    if (this.$user.role === 'ROLE_CZN_MANAGER' ||
        this.$user.role === 'ROLE_CZN_TERRITORIAL' ||
        this.$user.role === 'ROLE_REGIONAL_AGENCY' ||
        this.$user.role === 'ROLE_REGIONAL_ADMINISTRATOR'
    ) {
      this.userRegion = this.$cznDepartmentsByRegionList.find(region => region.code === this.$user.region.code);
    } else {
      this.userRegion = this.$cznDepartmentsByRegionList[0];
    }
    if (this.$user.role === 'ROLE_CZN_TERRITORIAL') {
      this.department = this.$user.department;
      this.monitoringLevel = 'czn';
    }
    await this.loadData();
  }
}
</script>

<style lang="scss">
@import "../../styles/main.scss";
</style>

<style lang="scss" scoped>
.reports-filters {
  margin-bottom: 16px;

  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    color: #1C1C1F;
    margin: 0 0 12px;
  }

  &__level {
    margin-top: 0;
    padding-top: 0;
    margin-bottom: 0;
  }

  &__selector {
    margin-top: 20px;

    ::v-deep .v-input {
      margin-bottom: 0;
    }

    ::v-deep .v-input__slot {
      margin-bottom: 0;
    }

    ::v-deep .v-text-field__details {
      display: none !important;
      min-height: 0 !important;
      height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden;
    }

    ::v-deep .two-columns {
      margin-bottom: 0;
      align-items: flex-end;

      > p {
        display: none;
      }
    }
  }

  &__wave {
    margin-top: 8px;
    margin-bottom: 20px;

    ::v-deep p {
      margin: 0;
    }
  }

  ::v-deep .v-text-field__details {
    display: none;
  }
}

.reports-block {
  margin-top: 20px;

  &:first-of-type {
    margin-top: 16px;
  }

  &__title {
    font-weight: 600;
    font-size: 18px;
    color: #1C1C1F;
    margin-bottom: 12px;
    padding: 10px 14px;
    background: #F5F8FC;
    border-radius: 4px;
  }

  &__empty {
    min-height: 48px;
    margin-top: 12px;
    padding-left: 8px;
    color: #5C5C61;
    font-size: 15px;
    font-style: italic;
  }
}

.list {
  table {
    border-collapse: collapse;
    width: 100%;

    th {
      border-bottom: 1px solid #E8E8E9;
    }

    td {
      padding: 10px 8px;
      vertical-align: middle;
    }
  }
}

.reports-table {
  table-layout: fixed;

  &__col-name {
    width: auto;
  }

  &__col-meta {
    width: 140px;
  }

  &__col-action {
    width: 64px;
  }

  th,
  td {
    padding: 10px 8px;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  th:last-child,
  td:last-child {
    padding-left: 4px;
    padding-right: 4px;
    overflow: visible;
    text-align: center;
  }

  th:not(:first-child),
  td:not(:first-child) {
    white-space: nowrap;
  }

  td:last-child .v-btn {
    min-width: 36px;
    padding: 0 4px;
  }
}
</style>
